// extracted by mini-css-extract-plugin
export default {"root":"ModalTitle_root__OwaQa","text":"ModalTitle_text__bRvmE","content":"ModalTitle_content__yvUar","closeIcon":"ModalTitle_closeIcon__iArM6"};